import { HighlightedText } from 'components/global-search/HighlightedText';
import { createContext, useContext } from 'react';
import { highlightSearchTerm } from 'utils/searchTermHighlight';

/**
 * The search term whose words `SearchTermHighlight` marks below it. Empty everywhere but under a
 * provider, so the names shared components render through it stay plain text elsewhere.
 */
export const SearchTermContext = createContext('');

/** `text` with the surrounding search term's words marked, or as it is when there is no term. */
export function SearchTermHighlight({ text }: { text: string | null | undefined }) {
    const searchTerm = useContext(SearchTermContext);
    if (!searchTerm || !text) {
        return text ?? null;
    }
    return <HighlightedText text={highlightSearchTerm(text, searchTerm)} />;
}
